import React from 'react';
import { ArrowRightIcon, CheckIcon, CalendarIcon, ClockIcon, UsersIcon, MonitorIcon, LayersIcon } from 'lucide-react';
import { PageTransition } from '../../components/layout/PageTransition';
import { Button } from '../../components/ui/Button';
import { Card } from '../../components/ui/Card';
import { DecorativeShape } from '../../components/DecorativeShape';
import { Animate } from '../../components/ui/Animate';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';
export function ArtOfFacilitation() {
  const {
    t
  } = useLanguage();
  const benefits = t('artOfFacilitation.benefits') as string[];
  const forWhomItems = t('artOfFacilitation.forWhomItems') as string[];
  const curriculum = t('artOfFacilitation.curriculum') as Array<{
    day: string;
    title: string;
    topics: string[];
  }>;
  return <PageTransition data-id="element-412" data-mp="2ogqja5xb719x">
      <div className="pt-12 pb-24" data-id="element-413" data-mp="2kgygyayidrd0">
        {/* Hero */}
        <section className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-20" data-id="element-414" data-mp="2kg6mx4kk81ou">
          <DecorativeShape type="blob" color="bg-emerald-100/50" className="top-0 right-0 w-[500px] h-[500px] translate-x-1/4 -translate-y-1/4 -z-10" data-id="element-415" data-mp="rzr2j9geb5qr" />
          <Animate className="max-w-3xl" data-id="element-416" data-mp="ixzxm6toj2xy">
            <span className="inline-block px-4 py-2 bg-emerald-50 text-emerald-700 font-medium rounded-full text-sm mb-6" data-id="element-417" data-mp="n04tlc7lobnr">
              {t('artOfFacilitation.badge')}
            </span>
            <h1 className="text-4xl md:text-6xl font-bold mb-4 leading-tight" data-id="element-418" data-mp="96wxp8chku09">
              {t('artOfFacilitation.title')}
              <br data-id="element-419" data-mp="3vggbt37d4tk4" />
              <span className="text-emerald-600" data-id="element-420" data-mp="3vgzkdtb4i5lh">{t('artOfFacilitation.titleHighlight')}</span>
            </h1>
            <p className="text-gray-500 text-lg mb-6 italic" data-id="element-421" data-mp="4aez6q7r1rwd">{t('artOfFacilitation.audienceNote')}</p>
            <p className="text-xl text-gray-600 mb-6 leading-relaxed" data-id="element-422" data-mp="3mgkz2ty5sqhz">
              {t('artOfFacilitation.aboutP1')}
            </p>
            <p className="text-xl text-gray-600 mb-8 leading-relaxed" data-id="element-423" data-mp="3rg5wgzxokqsl">
              {t('artOfFacilitation.aboutP2')}
            </p>
            <div className="flex flex-wrap gap-3 mb-8" data-id="element-424" data-mp="1s6wakcy176f8">
              <span className="flex items-center gap-2 bg-gray-100 text-gray-700 px-3 py-1.5 rounded-lg text-sm font-medium" data-id="element-425" data-mp="1s5bdafkc19do">
                <ClockIcon size={16} className="text-emerald-600" data-id="element-426" data-mp="1j6zqypqi0xr1" />
                {t('artOfFacilitation.duration')}
              </span>
              <span className="flex items-center gap-2 bg-gray-100 text-gray-700 px-3 py-1.5 rounded-lg text-sm font-medium" data-id="element-427" data-mp="2fvp8gey7roch">
                <MonitorIcon size={16} className="text-emerald-600" data-id="element-428" data-mp="2avt2wb9vbout" />
                {t('artOfFacilitation.format')}
              </span>
              <span className="flex items-center gap-2 bg-gray-100 text-gray-700 px-3 py-1.5 rounded-lg text-sm font-medium" data-id="element-429" data-mp="21xquhant1txi">
                <UsersIcon size={16} className="text-emerald-600" data-id="element-430" data-mp="vi6sommemdt9" />
                {t('artOfFacilitation.audience')}
              </span>
            </div>
            <Link to="/contact" data-id="element-431" data-mp="325e4zsip552c">
              <Button size="lg" rightIcon={<ArrowRightIcon size={20} data-id="element-433" data-mp="326yv95xza1ue" />} data-id="element-432" data-mp="32674c8fbssag">
                {t('artOfFacilitation.bookCta')}
              </Button>
            </Link>
          </Animate>
        </section>

        {/* What you learn */}
        <section className="bg-cream py-20 mb-20" data-id="element-434" data-mp="3b4sryhznmxi3">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-435" data-mp="3fxc73jdzq0p0">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start" data-id="element-436" data-mp="3fynavj7fr8g4">
              <Animate data-id="element-437" data-mp="3kvnhpwc40f8a">
                <h2 className="text-3xl font-bold text-charcoal mb-6" data-id="element-438" data-mp="3pv01u9blj876">
                  {t('artOfFacilitation.learnTitle')}
                </h2>
                <div className="space-y-3" data-id="element-439" data-mp="3uvebfvsuiq7b">
                  {benefits.map((benefit, i) => <div key={i} className="flex items-start gap-3" data-id="element-440" data-mp="2p909nemtn55" data-mpi={i}>
                      <div className="mt-1 p-1 rounded-full bg-emerald-100 text-emerald-700 flex-shrink-0" data-id="element-441" data-mp="20gbs6fue44cu">
                        <CheckIcon size={14} strokeWidth={3} data-id="element-442" data-mp="24h427bb36da6" />
                      </div>
                      <span className="text-gray-700" data-id="element-443" data-mp="196xr3q7sbhh9">{benefit}</span>
                    </div>)}
                </div>
              </Animate>
              <Animate delay={0.1} data-id="element-444" data-mp="157yd7g42sado">
                <h2 className="text-3xl font-bold text-charcoal mb-6" data-id="element-445" data-mp="1j5enx3temqb8">
                  {t('artOfFacilitation.forWhom')}
                </h2>
                <div className="space-y-3" data-id="element-446" data-mp="1e73bqmfn03pu">
                  {forWhomItems.map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-447" data-mp="qhiqfww0gude" data-mpi={i}>
                      <div className="mt-1 p-1 rounded-full bg-emerald-100 text-emerald-700 flex-shrink-0" data-id="element-448" data-mp="linyo5g2fvh5">
                        <UsersIcon size={14} data-id="element-449" data-mp="107u6ghsyyu0n" />
                      </div>
                      <span className="text-gray-700" data-id="element-450" data-mp="vgc4prj4gpem">{item}</span>
                    </div>)}
                </div>
              </Animate>
            </div>
          </div>
        </section>

        {/* Structure */}
        <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-20" data-id="element-451" data-mp="2qlpff5r7hgx">
          <Animate className="mb-12" data-id="element-452" data-mp="2ee8ebaei7c6x">
            <h2 className="text-3xl font-bold text-charcoal" data-id="element-453" data-mp="2ed75lckyn1sd">
              {t('artOfFacilitation.structureTitle')}
            </h2>
          </Animate>
          <div className="space-y-6" data-id="element-454" data-mp="25elo7kr85st6">
            {curriculum.map((day, i) => <Animate key={i} delay={i * 0.08} data-id="element-455" data-mp="29fnevd72swjj" data-mpi={i}>
                <Card className="p-6 border-2 border-emerald-100" data-id="element-456" data-mp="29ggpwqd2i87h">
                  <div className="flex items-start gap-4" data-id="element-457" data-mp="2x4q69crii3r8">
                    <div className="p-3 bg-emerald-50 rounded-xl flex-shrink-0" data-id="element-458" data-mp="2x358le9wi4p5">
                      <LayersIcon size={22} className="text-emerald-700" data-id="element-459" data-mp="323t1y6llqxmj" />
                    </div>
                    <div className="flex-1" data-id="element-460" data-mp="2o41telduu9fx">
                      <div className="flex flex-wrap items-baseline gap-3 mb-3" data-id="element-461" data-mp="2t3eccv1luwd8">
                        <span className="text-xs font-bold text-emerald-700 uppercase tracking-wide" data-id="element-462" data-mp="2t5h8zxx9jnqx">
                          {day.day}
                        </span>
                        <h3 className="font-bold text-charcoal text-lg" data-id="element-463" data-mp="1hq2cev8yuxwc">{day.title}</h3>
                      </div>
                      <ul className="grid grid-cols-1 md:grid-cols-2 gap-2" data-id="element-464" data-mp="3jfrg6bv5lbxy">
                        {day.topics.map((topic, j) => <li key={j} className="flex items-start gap-2 text-gray-600 text-sm" data-id="element-465" data-mp="39nbzdhvleten" data-mpi={j}>
                            <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-emerald-400 flex-shrink-0" data-id="element-466" data-mp="35ms3siqo3xum" />
                            {topic}
                          </li>)}
                      </ul>
                    </div>
                  </div>
                </Card>
              </Animate>)}
          </div>
        </section>

        {/* CTA */}
        <section className="max-w-4xl mx-auto px-4 text-center" data-id="element-467" data-mp="2mne89wdaif20">
          <Animate data-id="element-468" data-mp="2mp7bt2slwj5s">
            <Card className="p-12 bg-gradient-to-br from-emerald-50 to-teal/5 border-0" data-id="element-469" data-mp="2mpqx8thgtpok">
              <div className="w-16 h-16 mx-auto mb-6 bg-white rounded-full flex items-center justify-center shadow-md" data-id="element-470" data-mp="ovihsq8q8en9">
                <CalendarIcon size={32} className="text-emerald-600" data-id="element-471" data-mp="22twc1bpcsejp" />
              </div>
              <h2 className="text-3xl font-bold mb-4" data-id="element-472" data-mp="27sr4l5d4hhh0">{t('artOfFacilitation.ctaTitle')}</h2>
              <p className="text-gray-600 mb-8 max-w-xl mx-auto" data-id="element-473" data-mp="27qeeu614i2te">{t('artOfFacilitation.ctaDesc')}</p>
              <Link to="/contact" data-id="element-474" data-mp="2cltr4tjhfqnp">
                <Button variant="primary" rightIcon={<ArrowRightIcon size={18} data-id="element-476" data-mp="2gk9jlcyc1r8i" />} data-id="element-475" data-mp="2glav1ij9gfqr">
                  {t('artOfFacilitation.ctaCta')}
                </Button>
              </Link>
            </Card>
          </Animate>
        </section>
      </div>
    </PageTransition>;
}